import React from "react";
import { Box, Heading, Text, VStack, useColorModeValue, Skeleton } from "@chakra-ui/react";
import { Trans } from "@lingui/react/macro";
import { IValveData } from "../../types/alarmInterface";

interface IDataDumpValveProps {
  valveData: IValveData | null;
}

const getFormattedDate = (timestamp: string) => {
  const date = new Date(timestamp);
  return date.toLocaleString();
};

const DataDumpValve: React.FC<IDataDumpValveProps> = ({ valveData }) => {
  const bgColor = useColorModeValue("gray.50", "gray.800");

  if (valveData === null) {
    return <Skeleton height="20px" />;
  }

  return (
    <>
      {valveData.last_seen && (
        <Text>
          <Trans>Last Seen: </Trans> {getFormattedDate(valveData.last_seen)}
        </Text>
      )}
      <Text>
        <Trans>Current State: </Trans>
        {valveData.current_state ?? <Trans>Unknown</Trans>}
      </Text>
      {valveData.battery_voltage != null && (
        <Text>
          <Trans>Battery Voltage: </Trans>
          {valveData.battery_voltage.toFixed(2)} V
        </Text>
      )}
      {valveData.air_temperature != null && (
        <Text>
          <Trans>Air Temperature: </Trans>
          {valveData.air_temperature.toFixed(1)} ℃
        </Text>
      )}
      {valveData.humidity != null && (
        <Text>
          <Trans>Humidity: </Trans>
          {valveData.humidity.toFixed(0)} %
        </Text>
      )}
    </>
  );
};

export default DataDumpValve;
